import { Map as IMap } from 'immutable';
import { createSelector } from 'reselect';

export const getCurrencyPicker = state => state.get('currencyPicker', IMap());

export const getCurrencyPickerStatus = createSelector(
    getCurrencyPicker,
    loader => loader.get('isCurrencyPickerEnabled')
);

export const getCartIconForMobileStatus = createSelector(
    getCurrencyPicker,
    loader => loader.get('isCartIconEnabledForMobile')
);

export const getManageGiftcardsStatus = createSelector(
    getCurrencyPicker,
    loader => loader.get('isManageGiftcardsEnabled')
);

export const getLoginButtonStatus = createSelector(
    getCurrencyPicker,
    loader => loader.get('isLoginButtonEnabled', true)
);
